import { render } from "./DesignDialogs.vue?vue&type=template&id=c00e7edc&ts=true"
import script from "./DesignDialogs.vue?vue&type=script&lang=ts"
export * from "./DesignDialogs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__